import type { CharmInfo } from 'owa-calendar-charms-store';
import { CharmSelectionType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { dismissCharmSuggestions } from 'owa-calendar-charm-suggestions-store/lib/actions/charmSuggestionActions';
import {
    onCharmAndSelectionTypeChanged,
    onManualCharmChanged,
} from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';

/**
 * Updates the charm icon and charm selection type whenthe charm is set manually from
 * the charm picker
 */
export default orchestrator(onManualCharmChanged, actionMessage => {
    let charm = actionMessage.charm as CharmInfo;
    onCharmAndSelectionTypeChanged(charm, CharmSelectionType.Manual);
    dismissCharmSuggestions();
});
